// @flow
export const GRID_THEME_API = {
  container: '',
  item: ''
};
